/* TMC — size chart shell (v1.1).
   Wraps the Printify <table id="size-guide"> in a scroll container with a
   heading, scroll hint and footnote, strips its light-mode inline styles,
   and cleans up Printify's typos. Footnote adapts: garments get fit advice,
   blankets and tapestries get dimension wording. */
(function(){
  var FIXES=[[/^Lenght,/i,'Length,'],[/^Sleeve length from center back,/i,'Sleeve length (from center back),']];

  function clean(t){
    t.removeAttribute('style');
    t.querySelectorAll('[style]').forEach(function(n){n.removeAttribute('style')});
    t.querySelectorAll('[width],[height],[bgcolor],[align]').forEach(function(n){
      n.removeAttribute('width');n.removeAttribute('height');n.removeAttribute('bgcolor');n.removeAttribute('align');
    });
    /* fix Printify's misspellings in the label column */
    t.querySelectorAll('tbody tr > td:first-child').forEach(function(td){
      var s=(td.textContent||'').trim();
      FIXES.forEach(function(f){s=s.replace(f[0],f[1])});
      if(s!==td.textContent.trim())td.textContent=s;
    });
  }

  function build(t){
    if(!t||t.closest('.tmc-size'))return;
    clean(t);

    var cols=t.querySelectorAll('thead th').length-1;
    var isGarment=cols>1;
    var body=(t.textContent||'');
    var metric=/,\s*cm/i.test(body);

    var wrap=document.createElement('div');wrap.className='tmc-size';
    var head=document.createElement('div');head.className='tmc-size-head';
    head.innerHTML='<b>'+(isGarment?'Size chart':'Dimensions')+'</b><span class="hint"></span>';
    var scroll=document.createElement('div');scroll.className='tmc-size-scroll';
    var foot=document.createElement('div');foot.className='tmc-size-foot';
    foot.textContent=isGarment
      ? 'Garment measurements laid flat, not body measurements. Allow for the size tolerance listed above. Runs true to size \u2014 size up for an oversized fit.'
      : 'Finished product dimensions. Small variation is normal on printed textiles.';

    t.parentNode.insertBefore(wrap,t);
    scroll.appendChild(t);
    wrap.appendChild(head);wrap.appendChild(scroll);wrap.appendChild(foot);

    var hint=head.querySelector('.hint');
    var unit=metric?'Measurements in cm':'Measurements in inches';
    function sync(){
      var over=scroll.scrollWidth>scroll.clientWidth+4;
      wrap.classList.toggle('is-scrollable',over);
      wrap.classList.toggle('at-end',over&&scroll.scrollLeft+scroll.clientWidth>=scroll.scrollWidth-2);
      if(hint)hint.textContent=over?'Swipe for all sizes \u2192':unit;
    }
    scroll.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',sync);
    sync();setTimeout(sync,350);
  }

  function scan(){
    document.querySelectorAll('table#size-guide, .product__description table, .rte table').forEach(build);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',scan)}else{scan()}
  document.addEventListener('shopify:section:load',function(){setTimeout(scan,60)});
})();
